import { createStore } from "../lib/store"
import { ProfileStore } from "./index"
import { getTraits, definitions } from "./functions"
import { reaction } from "mobx"
import history from "../history"
import randomColor from "randomcolor"
const hues = ["blue", "red", "green", "yellow", "purple", "orange"]

const state = {
  size: { width: 0, height: 0 },
  loading: true,
  location: null,
  prompt: false,
  profiles: [],
  get emptyData() {
    let traits = getTraits("INTP")
    return Object.keys(traits).map(k => {
      return { axis: traits[k].name, value: 0 }
    })
  },
  get chartData() {
    if (!this.profiles.length)
      return [{ chart: this.emptyData, color: "#fffffff" }]

    return this.profiles.map(p => {
      return { chart: p.chartTraits, color: p.color }
    })
  },
  get mergedTraits() {
    // loop through
    const merged = this.profiles.reduce((m, p) => {
      return p.attributes.reduce((m, t) => {
        if (!m[t.name]) m[t.name] = 0
        m[t.name] += t.weight
        return m
      }, m)
    }, {})

    return Object.keys(merged).map(key => {
      return { name: key, weight: merged[key], definition: definitions[key] }
    })
  },
  get slug() {
    return this.profiles
      .map(
        p =>
          `${p.name.toLowerCase().replace(" ", "-")}--${p.mbti.toLowerCase()}`
      )
      .join("_")
  },
  get pathname() {
    return (this.location.pathname.replace("/", "") || "").toLowerCase()
  },
  get shouldSetProfilesFromSlug() {
    return this.pathname.length > 0 && this.pathname !== this.slug
  },
  get promptForProfile() {
    return !this.loading && (this.prompt || this.profiles.length === 0)
  },
  get canClosePrompt() {
    return this.profiles.length > 0
  },
  get url() {
    return `https://www.pers0nal1ty.com/${this.slug || ""}`
  },
  get shareMeta() {
    return {
      title: "P E R S O N A L 1 T Y",
      description: "Visualize personality"
    }
  },
  get orderedTraits() {
    return this.mergedTraits.sort((a, b) => (a.weight > b.weight ? -1 : 1))
  },
  get strongestTraits() {
    return this.mergedTraits
      .sort((a, b) => (a.weight > b.weight ? -1 : 1))
      .slice(0, 5)
  },
  get weakestTraits() {
    return this.mergedTraits
      .sort((a, b) => (a.weight > b.weight ? 1 : -1))
      .slice(0, 5)
  },
  // helpers
  fitSize(target, fallbackPerc, min) {
    if (target <= this.size.width) {
      return target
    } else {
      const perc = this.size.width * fallbackPerc
      return perc > min ? perc : min
    }
  }
}

const actions = {
  setSize(width, height) {
    this.size = { width, height }
  },
  prompt(value) {
    this.prompt = value
  },
  setLocation(location) {
    this.location = location
    if (this.shouldSetProfilesFromSlug) this.action.loadProfilesFromPath()
    this.loading = false
  },
  addProfile(name, mbti) {
    const profile = new ProfileStore()
    const i = this.profiles.length % hues.length
    const hue = hues[i]
    profile.color = randomColor({
      luminosity: "light",
      hue
    })

    profile.order = this.profiles.length
    profile.action.set(name, mbti, this.profiles.length)
    this.profiles.push(profile)
    this.prompt = false
    this.action.updateOrder()
  },
  removeProfile(index) {
    const p = this.profiles.find((item, i) => i === index)
    this.profiles.remove(p)
    this.action.updateOrder()
  },
  loadProfilesFromPath() {
    this.pathname.split("_").map(s => {
      let [name, mbti] = s.split("--")
      name = name.replace("-", " ")
      this.action.addProfile(name, mbti)
    })
  },
  updateOrder() {
    this.profiles.map((p, i) => {
      p.order = i
      return p
    })
  }
}

const reactions = {
  onProfilesChanged: function() {
    return reaction(
      () => this.slug,
      slug => {
        if (this.pathname !== this.slug) {
          history.replace(this.slug)
        }
      }
    )
  }
}

export default createStore(state, actions, reactions)



// WEBPACK FOOTER //
// ./src/store/app.js